module.exports = __webpack_public_path__ + "static/img/kcbj.96b632b3.png";